import { useAuth } from '@/lib/auth';
import { Button } from '@/components/ui/button';
import { ArrowLeft, ShieldAlert } from 'lucide-react';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export function ImpersonateBanner() {
  const { user, refresh, isImpersonating } = useAuth();

  if (!isImpersonating || !user) return null;

  async function exitImpersonation() {
    try {
      await api.post('/v1/auth/impersonate/exit');
      await refresh();
      toast.success('Saiu da impersonação. Você é o Master novamente.');
    } catch (e) {
      toast.error('Não foi possível sair da impersonação.');
    }
  }

  return (
    <div className="sticky top-14 z-20 flex items-center justify-between gap-3 bg-butter px-4 py-2 text-butter-deep border-b border-butter-deep/20">
      <div className="flex items-center gap-2 text-sm">
        <ShieldAlert className="h-4 w-4 shrink-0" strokeWidth={1.8} />
        <span>
          Você está impersonando o workspace <strong>{user.workspaceName ?? '—'}</strong>. Tudo que
          você fizer aqui é auditado.
        </span>
      </div>
      <Button variant="ghost" size="sm" onClick={exitImpersonation} className="hover:bg-butter-deep/10">
        <ArrowLeft className="h-3.5 w-3.5 mr-1" strokeWidth={1.8} />
        Sair da impersonação
      </Button>
    </div>
  );
}
